var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.06544 39.7104L0.0359784 17.3834C-0.0793495 17.0583 0.0918552 16.6981 0.416989 16.5793C10.9738 12.7825 22.8695 9.25113 33.0382 4.91228C33.4926 4.62562 33.8492 4.90882 34.045 5.45067L46.6607 37.9693L50.0865 47.4966C50.2018 47.8218 50.0341 48.1854 49.7089 48.3008L25.5681 56.982L16.1578 60.3664C15.8327 60.4853 15.4726 60.314 15.3539 59.9889L8.06544 39.7104Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.759 32.3021L10.7496 8.91917C10.6901 8.57652 10.9209 8.25139 11.26 8.19194L38.8719 3.45801L45.1956 2.41613C45.5417 2.26578 46.1045 2.44056 46.2372 3.2133L53.0676 37.3228L54.7771 47.3012C54.8365 47.6404 54.6057 47.969 54.2667 48.0284L28.9827 52.3638L19.125 54.056C18.7859 54.112 18.4574 53.8812 18.3979 53.542L14.759 32.3021Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4952 25.4073V47.8882C22.4952 48.2484 22.7889 48.5455 23.149 48.5455H33.5834H49.0306H51.2503H60.346C60.706 48.5455 60.9997 48.2484 60.9997 47.8882V37.3261V8.1498V7.84563H54.358C53.7183 7.84563 52.3899 7.93654 52.3899 6.48565L52.3759 0H23.1488C22.7888 0 22.4951 0.293681 22.4951 0.653842V6.26536V8.63935V25.4073H22.4952Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4142 12.7964C7.67395 14.0551 3.96856 15.3032 0.416989 16.5793C0.0918552 16.6982 -0.0793495 17.0583 0.0359784 17.3834L8.06544 39.7106L15.3539 59.9889C15.4728 60.314 15.8328 60.4853 16.1578 60.3664L25.5681 56.982L47.0104 49.2728L11.4142 12.7964Z",
    fill: "#D48CB5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4949 6.26538L11.26 8.19176C10.9209 8.25121 10.6901 8.57635 10.7496 8.91899L11.4138 12.7963L14.7591 32.302L18.398 53.5417C18.4575 53.8809 18.7861 54.1116 19.1251 54.0557L28.9828 52.3635L47.0098 49.2728L51.25 48.5456H49.0303L22.4949 6.26538Z",
    fill: "#E1B0CC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.9996 37.3261V8.1498V7.84563V7.74424C60.9996 7.55541 60.9192 7.52395 60.6291 7.24076L53.4596 0.402099C53.1205 0.0804198 53.0646 0 52.8653 0H52.3759H23.1488C22.7888 0 22.4951 0.293681 22.4951 0.653842V47.8882C22.4951 48.2484 22.7888 48.5455 23.1488 48.5455H60.3459C60.7059 48.5455 60.9996 48.2484 60.9996 47.8882V37.3261Z",
    fill: "#EAC7DB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4955 6.26538L19.8633 6.71645V50.3043C19.8633 50.6679 20.157 50.9616 20.517 50.9616H30.9514H37.1597L47.0104 49.2729L51.2506 48.5457H49.0309H46.3008H33.5836H23.1492C22.7891 48.5457 22.4955 48.2486 22.4955 47.8884C22.4955 34.0151 22.4955 20.1384 22.4955 6.26538Z",
    fill: "#D298B9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.759 32.3021L11.4137 12.7964C10.5083 13.1006 9.60645 13.4047 8.70801 13.7089L9.12405 16.1318L12.4694 35.6375L16.1119 56.8773C16.1677 57.2163 16.4963 57.4471 16.8354 57.3912L26.6931 55.6991L31.3703 54.8985L45.4577 49.8289L45.2899 49.5667L37.1591 50.9617L28.9828 52.3637L19.1252 54.0559C18.7861 54.1119 18.4575 53.8811 18.3981 53.5419L14.759 32.3021Z",
    fill: "#C677A4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.9997 37.3261V8.1498V7.84563C60.9997 7.4925 60.8844 7.48905 60.6292 7.24076L53.4597 0.402099C53.1207 0.0804198 53.0648 0 52.8655 0H52.376H45.1016C53.991 11.9013 54.4978 33.3543 47.9016 46.745C47.5974 47.3674 47.2793 47.9652 46.9473 48.5455H49.0307H51.2504H60.346C60.7061 48.5455 60.9997 48.2484 60.9997 47.8882V37.3261Z",
    fill: "#E1B6CF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.3899 6.48565C52.3899 7.93654 53.7182 7.84563 54.358 7.84563H60.9997V7.74424C60.9997 7.55541 60.9193 7.52395 60.6292 7.24076L53.4597 0.402099C53.1206 0.0804198 53.0647 0 52.8654 0H52.376L52.3899 6.48565Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.6292 7.24076L53.4597 0.402099C53.1206 0.0804198 53.0647 0 52.8654 0H52.376L52.3899 6.48553C52.3899 7.93642 53.7182 7.84551 54.358 7.84551H60.9997V7.74413C60.9997 7.55541 60.9193 7.52395 60.6292 7.24076Z",
    fill: "#D298B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0921 14.298H28.7735C28.2651 14.298 27.853 13.8857 27.853 13.3771C27.853 12.8685 28.2651 12.4563 28.7735 12.4563H55.0921C55.6005 12.4563 56.0126 12.8685 56.0126 13.3771C56.0126 13.8857 55.6006 14.298 55.0921 14.298Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0921 20.8392H28.7735C28.2651 20.8392 27.853 20.427 27.853 19.9184C27.853 19.4098 28.2651 18.9976 28.7735 18.9976H55.0921C55.6005 18.9976 56.0126 19.4098 56.0126 19.9184C56.0126 20.427 55.6006 20.8392 55.0921 20.8392Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0921 27.3805H28.7735C28.2651 27.3805 27.853 26.9683 27.853 26.4597C27.853 25.951 28.2651 25.5388 28.7735 25.5388H55.0921C55.6005 25.5388 56.0126 25.951 56.0126 26.4597C56.0126 26.9683 55.6006 27.3805 55.0921 27.3805Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0921 33.9222H28.7735C28.2651 33.9222 27.853 33.51 27.853 33.0014C27.853 32.4928 28.2651 32.0806 28.7735 32.0806H55.0921C55.6005 32.0806 56.0126 32.4928 56.0126 33.0014C56.0126 33.51 55.6006 33.9222 55.0921 33.9222Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0921 40.4637H28.7735C28.2651 40.4637 27.853 40.0515 27.853 39.5429C27.853 39.0343 28.2651 38.6221 28.7735 38.6221H55.0921C55.6005 38.6221 56.0126 39.0343 56.0126 39.5429C56.0126 40.0515 55.6006 40.4637 55.0921 40.4637Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.b1998ded.svg";
export { ForwardRef as ReactComponent };